// Single-source dynamic import factory for the conversation-assistant chunk.
// Mirrors the chunk-name used by the live lazy()/loadable() boundaries so preload
// and the live boundaries share the same chunk identity.
export const importConversationAssistant = (): Promise<typeof import('./ConversationAssistant')> =>
	import(/* webpackChunkName: "@atlassian/conversation-assistant" */ './ConversationAssistant');
